import { renderToString } from "react-dom/server";
import Booklet_Entity from "./booklet";
import { AppConfig } from "environement";
import { Musician } from "entities/musician";
import { SeasonUtils } from "features/seasons/SeasonUtils";
import moment from "moment";
import { Project } from "entities/project";
import { WorkSession } from "entities/workSession";
import { LayoutUtils } from "features/projects/ProjectMissionControl/LayoutUtils";
import { RosterOptions } from "hooks/projectRoster/projectRoster";
export default class Booklet extends Booklet_Entity {
  static fromList(bookletsJSON: unknown): Array<Booklet> {
    const booklets: Booklet[] = [];
    if (bookletsJSON)
      Array.isArray(bookletsJSON) &&
        bookletsJSON.forEach((bookletJSON) => {
          booklets.push(new Booklet(bookletJSON));
        });
    return booklets;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  publicUrl(): string {
    const apiEndpoint = AppConfig.api.endpoint;
    let endpoint = "live";
    if (apiEndpoint.includes("alpha")) endpoint = "alpha";
    if (apiEndpoint.includes("demo")) endpoint = "demo";

    return `https://booklet.${endpoint}.rhapsody.la?token=${this.publicToken}`;
  }

  contract(musician: Musician, utils: SeasonUtils): string {
    let content = this.content;

    const { workSessions } = utils;
    let start;

    workSessions.forEach((w) => {
      if (!w.isTBD() && !start)
        start = moment(w.dateFromUTC).format("MMM Do YYYY");
    });
    if (!start) start = "N/A";

    const end = workSessions.length
      ? moment(workSessions[workSessions.length - 1].dateFromUTC).format(
          "MMM Do YYYY"
        )
      : "N/A";

    const assignments = utils.assignments.filter(
      (a) => a.musicianID === musician.id
    );
    const _projects = assignments.reduce<Project[]>((a, v) => {
      const project = utils.projectsMap[v.projectID];
      a.push(project);
      return a;
    }, []);

    const _workSessions = assignments.reduce<WorkSession[]>((a, v) => {
      let workSessionIDs = [];
      try {
        workSessionIDs = JSON.parse(v.workSessionIDs);
      } catch (error) {}

      workSessionIDs.forEach((workSessionID) => {
        a.push(utils.workSessionsMap[workSessionID]);
      });
      return a;
    }, []);

    console.log(utils, musician, assignments, _projects, _workSessions);

    content = content.replace(/{{\.MusicianName}}/g, musician.fullName());
    content = content.replace(
      /{{\.MusicianFullName}}/g,
      `${musician.firstName} ${musician.middleName} ${musician.lastName}`
    );
    content = content.replace(/{{\.SeasonStart}}/g, start);
    content = content.replace(/{{\.SeasonEnd}}/g, end);
    content = content.replace(/{{\.Instrument}}/g, musician.instrumentNames);
    content = content.replace(/{{\.Projects}}/g, `${_projects.length}`);
    content = content.replace(/{{\.WorkSessions}}/g, `${_workSessions.length}`);
    content = content.replace(/{{\.BaseRate}}/g, "$0.00");
    content = content.replace(/{{\.MusicianNickname}}/g, musician.nickName);
    content = content.replace(/{{\.CompanyName}}/g, musician.companyName);
    content = content.replace(/{{\.Email}}/g, musician.email);
    content = content.replace(/{{\.Phone}}/g, musician.phone);
    content = content.replace(/{{\.Address}}/g, musician.address);
    content = content.replace(/{{\.City}}/g, musician.city);
    content = content.replace(/{{\.State}}/g, musician.state);
    content = content.replace(/{{\.Zipcode}}/g, musician.zipcode);
    content = content.replace(
      /{{\.Ssn}}/g,
      `${musician.ssn} / ${musician.ein}`
    );
    content = content.replace(/{{\.SeasonName}}/g, utils.tag.name);

    content = content.replace(
      /{{\.Mission}}/g,
      this.getMissionDetails(utils, _projects, _workSessions)
    );

    console.log(content);

    return content;
  }

  getMissionDetails(
    utils: SeasonUtils,
    projects: Project[],
    workSessions: WorkSession[]
  ) {
    const content = (
      <>
        {projects.map((p) => {
          const ws = workSessions.filter((w) => w.projectID === p.id);
          const projectPieces = utils.projectPieces.filter(
            (pp) => pp.projectID === p.id
          );

          return (
            <table
              key={p.id}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                marginBottom: "16px",
              }}
              border={1}
              cellPadding="5"
            >
              <thead>
                <tr style={{ backgroundColor: "black", color: "white" }}>
                  <th colSpan={5}>{p.name}</th>
                </tr>
                {projectPieces.map((pp) => {
                  const piece = utils.piecesMap[pp.pieceID];
                  if (!piece)
                    return (
                      <>
                        <tr style={{ backgroundColor: "#e0e0e0" }}>
                          <th>Seating Assignment</th>
                          <th colSpan={3}></th>
                          <th>- minutes</th>
                        </tr>
                        <tr>
                          <td colSpan={5}>{pp.description}</td>
                        </tr>
                      </>
                    );
                  return (
                    <>
                      <tr style={{ backgroundColor: "#e0e0e0" }}>
                        <th>{piece.composer}</th>
                        <th colSpan={3}>{piece.name}</th>
                        <th>- minutes</th>
                      </tr>
                      <tr>
                        <td colSpan={5}>{pp.description}</td>
                      </tr>
                    </>
                  );
                })}
                <tr style={{ backgroundColor: "#666666", color: "white" }}>
                  <th>Service List</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {ws.map((item, idx) => (
                  <tr key={idx} style={{ backgroundColor: "#eaf3e0" }}>
                    <td>{item.title}</td>
                    <td>{item.formatDate()}</td>
                    <td>
                      {item.formatFrom()}-{item.formatTo()}
                    </td>
                    <td>{item.studioName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          );
        })}
      </>
    );
    return renderToString(content);
  }

  dynamic(): string {
    return renderToString(
      <>
        <div
          className={`readonly-block booklet-${this.id}`}
          dangerouslySetInnerHTML={{
            __html: this.content,
          }}
        />
        <br />
      </>
    );
  }
}
